<template>
  <div>
    <a-modal v-model="visible" title="流程发布队列" width="740px" :body-style="{ maxHeight: '80vh', overflowY: 'auto', padding: '16px' }" :footer="null" wrap-class-name="workflow-queue-modal" @cancel="handleCancel">
      <a-alert message="由于以下流程之间存在版本冲突，请根据发布队列依次发布，若无发布权限可提醒对应流程的发布人" type="info" show-icon style="margin-bottom: 8px" />
      <a-spin :spinning="loading">
        <div v-if="items.length" class="workflow-queue-list">
          <div v-for="(item, index) in items" :key="item.workflow_id" class="workflow-queue-item">
            <div class="workflow-title-row">
              <span class="workflow-title" :title="item.workflow_title">
                <a-badge :count="index + 1" :number-style="{ backgroundColor: '#108EE9' }" style="margin-right: 8px" />
                <a-tag :color="workflowStatus[item.workflow_status]?.color || 'default'">
                  {{ workflowStatus[item.workflow_status]?.label }}
                </a-tag>
                <span class="workflow-title-ellipsis">{{ item.workflow_title }}</span>
                <span class="workflow-id"># {{ item.workflow_id }}</span>
              </span>
              <a-button type="primary" size="small" class="publish-btn" @click="onDetail(item)">去发布</a-button>
            </div>
            <div v-if="item.ops" class="workflow-operator">
              <user-profiles :value="item.ops" avatar />
            </div>
            <a-list :data-source="item.services" class="workflow-service-list" :split="false">
              <a-list-item slot="renderItem" slot-scope="service" class="workflow-service-list-item">
                <span class="service-name">{{ service.service_name }}</span>
                <span class="service-version">{{ service.artifact_version }}</span>
              </a-list-item>
            </a-list>
          </div>
        </div>
        <a-empty v-else description="暂无排队任务" />
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { workflowStatus } from '@/utils/dictionary';
import { queryWorkflowDeploymentQueue } from '@/api/project/workflow';

export default {
  data() {
    return {
      workflowStatus,
      visible: false,
      loading: false,
      items: []
    };
  },
  methods: {
    open(workflowId) {
      this.visible = true;
      this.fetchQueue(workflowId);
    },
    handleCancel() {
      this.visible = false;
    },
    fetchQueue(workflowId) {
      this.loading = true;
      queryWorkflowDeploymentQueue({ workflow_id: workflowId })
        .then(res => {
          this.items = res.data.items;
        })
        .catch(e => {
          this.items = [];
          this.$message.error('获取队列异常');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 查看流程详情
     * @param {*} record
     */
    onDetail(record) {
      const route = this.$router.resolve({
        name: 'page:project:workflow:detail',
        params: { project_id: record.project_id },
        query: { workflowId: record.workflow_id }
      });
      window.open(route.href);
    }
  }
};
</script>

<style scoped>
.workflow-queue-modal .ant-modal-content {
  border-radius: 12px;
}
.workflow-queue-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 0;
}
.workflow-queue-item {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  padding: 12px;
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
  transition: box-shadow 0.2s;
  border: 1px solid #f0f0f0;
}
.workflow-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
  gap: 8px;
}
.workflow-status-tag {
  margin-right: 8px;
  font-size: 13px;
  height: 22px;
  line-height: 20px;
  padding: 0 10px;
  border-radius: 6px;
}
.workflow-title {
  font-size: 15px;
  color: #222;
  max-width: 600px;
  display: flex;
  align-items: center;
  vertical-align: middle;
  flex: 1;
  min-width: 0;
}
.workflow-title-ellipsis {
  display: inline-block;
  max-width: 450px;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.workflow-id {
  color: #888;
  font-size: 13px;
  margin-left: 8px;
  flex-shrink: 0;
}
.publish-btn {
  margin-left: 12px;
  border-radius: 6px;
  font-size: 13px;
  padding: 0 14px;
  height: 28px;
}
.workflow-operator {
  color: #888;
  margin: 4px 0;
}
.workflow-service-list {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 2px 0 0 0;
  margin-top: 4px;
}
.workflow-service-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none !important;
  padding: 4px 10px 4px 6px;
  font-size: 13px;
  border-radius: 4px;
  margin-bottom: 0;
}
.service-name {
  color: #333;
}
.service-version {
  color: #888;
  font-size: 12px;
  margin-left: 8px;
}
</style>
